
(() => {
  const selector = '[data-bio-invoice]';
  const keys = ['request', 'name', 'vat', 'activity', 'taxoffice'];
  const resumed = new WeakSet();
  let pending = Promise.resolve();

  function field(root, key) {
    return root.querySelector(`[data-invoice-${key}]`);
  }

  function updateDisplay(root) {
    field(root, 'details').hidden = !field(root, 'request').checked;
    field(root, 'error').hidden = true;
  }

  function synchronize(root) {
    document.querySelectorAll(selector).forEach(other => {
      if (other === root) return;

      keys.forEach(key => {
        if (key === 'request') {
          field(other, key).checked = field(root, key).checked;
        } else {
          field(other, key).value = field(root, key).value;
        }
      });

      updateDisplay(other);
    });
  }

  function attributes(root) {
    const requested = field(root, 'request').checked;
    const value = key => requested ? field(root, key).value.trim() : '';

    return {
      'Invoice Requested': requested ? 'Yes' : 'No',
      'Invoice Name': value('name'),
      'Invoice VAT': value('vat'),
      'Invoice Activity': value('activity'),
      'Invoice Tax Office': value('taxoffice')
    };
  }

  function save(root) {
    const data = attributes(root);
    const base = window.Shopify?.routes?.root || '/';

    pending = pending.catch(() => {}).then(async () => {
      const response = await fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: data })
      });

      if (!response.ok) throw new Error('Cart save failed');
      return response.json();
    });

    return pending;
  }

  document.addEventListener('input', event => {
    const root = event.target.closest(selector);
    if (!root) return;
    updateDisplay(root);
    synchronize(root);
  });

  document.addEventListener('change', event => {
    const root = event.target.closest(selector);
    if (!root) return;

    updateDisplay(root);
    synchronize(root);
    save(root).catch(() => {
      field(root, 'error').textContent =
        'Could not save invoice details. Please try again.';
      field(root, 'error').hidden = false;
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.closest(selector)) {
      event.preventDefault();
    }
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest(
      '.cart__checkout-wrapper [name="checkout"], ' +
      '.cart__checkout-wrapper .cart__checkout'
    );

    if (!button) return;

    if (resumed.has(button)) {
      resumed.delete(button);
      return;
    }

    const wrapper = button.closest('.cart__checkout-wrapper');
    const root = wrapper?.parentElement?.querySelector('[data-bio-invoice]');

    if (!root) return;  

    event.preventDefault();
    event.stopImmediatePropagation();

    if (field(root, 'request').checked) {
      const name = field(root, 'name').value.trim();
      const vat = field(root, 'vat').value.trim();

      if (!name || !/^\d{9}$/.test(vat)) {
        field(root, 'error').hidden = false;
        (!name ? field(root, 'name') : field(root, 'vat')).focus();
        return;
      }
    }

    button.disabled = true;

    try {
      await save(root);
      button.disabled = false;
      resumed.add(button);
      button.click();
    } catch (error) {
      button.disabled = false;
      field(root, 'error').textContent =
        'Could not save invoice details. Please try again.';
      field(root, 'error').hidden = false;
    }
  }, true);
})();
